import { Type, Wand2 } from 'lucide-react'
import { useLocation } from 'react-router-dom'
import { PageDescription, RoutingTabs } from '@/components/ui'

// Mirrors VideoTabs / ImageTabs in shape so the visual treatment is
// identical. Keeps the entire character creation + edit flow on a
// single section route so it feels isolated from generic image tools.
const characterTabs = [
  {
    id: 't2c',
    label: 'Text to Character',
    icon: Type,
    path: '/characters',
    description:
      'Create a character and use them to generate other spice images and videos.',
  },
  {
    id: 'edit',
    label: 'Edit Character',
    icon: Wand2,
    path: '/characters/edit',
    description:
      'Refine an existing character. Branch new edits off the canonical or any previous version.',
  },
]

export function CharacterTabs() {
  const location = useLocation()
  // `Edit Character` lives at `/characters/edit` and may carry a
  // query string (`?name=`) — the pathname stays exact so a strict
  // match still works for the active-tab highlight.
  const active = characterTabs.find((tab) => location.pathname === tab.path)
  return (
    <>
      <RoutingTabs items={characterTabs} />
      {active?.description && (
        <PageDescription className="mt-3">{active.description}</PageDescription>
      )}
    </>
  )
}
